import { agentFetcher } from '@/api/base/agentFetcher'
import type { DashboardResult } from '@/api/types/dashboard.types'

export const dashboardService = {
  getDashboard: (workspaceId: number) =>
    agentFetcher.get<DashboardResult>('/user/workspace/dashboard', { workspaceId }),
}
